import about_af from './pages/af/about.html';
import about_zu from './pages/zu/about.html';
import access_denied_af from './pages/af/access_denied.html';
import access_denied_zu from './pages/zu/access_denied.html';
import add_edit_performance_management_af from './pages/af/add_edit_performance_management.html';
import add_edit_performance_management_zu from './pages/zu/add_edit_performance_management.html';
import anonymous_survey_af from './pages/af/anonymous_survey.html';
import anonymous_survey_zu from './pages/zu/anonymous_survey.html';
import approve_documents_af from './pages/af/approve_documents.html';
import approve_documents_zu from './pages/zu/approve_documents.html';
import approve_leave_af from './pages/af/approve_leave.html';
import approve_leave_zu from './pages/zu/approve_leave.html';
import approve_users_af from './pages/af/approve_users.html';
import approve_users_zu from './pages/zu/approve_users.html';
import birthday_report_af from './pages/af/birthday_report.html';
import birthday_report_zu from './pages/zu/birthday_report.html';
import branches_af from './pages/af/branches.html';
import branches_zu from './pages/zu/branches.html';
import calendar_af from './pages/af/calendar.html';
import calendar_zu from './pages/zu/calendar.html';
import companies_af from './pages/af/companies.html';
import companies_zu from './pages/zu/companies.html';
import contract_type_af from './pages/af/contract_type.html';
import contract_type_zu from './pages/zu/contract_type.html';
import departments_af from './pages/af/departments.html';
import departments_zu from './pages/zu/departments.html';
import document_categories_af from './pages/af/document_categories.html';
import document_categories_zu from './pages/zu/document_categories.html';
import documents_af from './pages/af/documents.html';
import documents_zu from './pages/zu/documents.html';
import employee_attendance_report_af from './pages/af/employee_attendance_report.html';
import employee_attendance_report_zu from './pages/zu/employee_attendance_report.html';
import employee_count_report_af from './pages/af/employee_count_report.html';
import employee_count_report_zu from './pages/zu/employee_count_report.html';
import employee_create_af from './pages/af/employee_create.html';
import employee_create_zu from './pages/zu/employee_create.html';
import employee_dashboard_af from './pages/af/employee_dashboard.html';
import employee_dashboard_zu from './pages/zu/employee_dashboard.html';
import employee_disciplinary_report_af from './pages/af/employee_disciplinary_report.html';
import employee_disciplinary_report_zu from './pages/zu/employee_disciplinary_report.html';
import employee_document_count_report_af from './pages/af/employee_document_count_report.html';
import employee_document_count_report_zu from './pages/zu/employee_document_count_report.html';
import employee_employment_listing_report_af from './pages/af/employee_employment_listing_report.html';
import employee_employment_listing_report_zu from './pages/zu/employee_employment_listing_report.html';
import employee_field_report_af from './pages/af/employee_field_report.html';
import employee_field_report_zu from './pages/zu/employee_field_report.html';
import employee_fields_af from './pages/af/employee_fields.html';
import employee_fields_zu from './pages/zu/employee_fields.html';
import employee_groups_af from './pages/af/employee_groups.html';
import employee_groups_zu from './pages/zu/employee_groups.html';
import employee_leave_af from './pages/af/employee_leave.html';
import employee_leave_zu from './pages/zu/employee_leave.html';
import employee_list_new_af from './pages/af/employee_list_new.html';
import employee_list_new_zu from './pages/zu/employee_list_new.html';
import employee_notifications_af from './pages/af/employee_notifications.html';
import employee_notifications_zu from './pages/zu/employee_notifications.html';
import employee_redirect_af from './pages/af/employee_redirect.html';
import employee_redirect_zu from './pages/zu/employee_redirect.html';
import employee_role_list_af from './pages/af/employee_role_list.html';
import employee_role_list_zu from './pages/zu/employee_role_list.html';
import employee_search_af from './pages/af/employee_search.html';
import employee_search_zu from './pages/zu/employee_search.html';
import employee_view_af from './pages/af/employee_view.html';
import employee_view_zu from './pages/zu/employee_view.html';
import employees_currently_on_leave_report_af from './pages/af/employees_currently_on_leave_report.html';
import employees_currently_on_leave_report_zu from './pages/zu/employees_currently_on_leave_report.html';
import employees_future_leave_report_af from './pages/af/employees_future_leave_report.html';
import employees_future_leave_report_zu from './pages/zu/employees_future_leave_report.html';
import events_af from './pages/af/events.html';
import events_zu from './pages/zu/events.html';
import faq_af from './pages/af/faq.html';
import faq_zu from './pages/zu/faq.html';
import features_roles_af from './pages/af/features_roles.html';
import features_roles_zu from './pages/zu/features_roles.html';
import general_document_categories_af from './pages/af/general_document_categories.html';
import general_document_categories_zu from './pages/zu/general_document_categories.html';
import holidays_af from './pages/af/holidays.html';
import holidays_zu from './pages/zu/holidays.html';
import leave_cancellation_request_af from './pages/af/leave_cancellation_request.html';
import leave_cancellation_request_zu from './pages/zu/leave_cancellation_request.html';
import leave_categories_af from './pages/af/leave_categories.html';
import leave_categories_zu from './pages/zu/leave_categories.html';
import leave_rules_af from './pages/af/leave_rules.html';
import leave_rules_zu from './pages/zu/leave_rules.html';
import leave_taken_by_leave_type_af from './pages/af/leave_taken_by_leave_type.html';
import leave_taken_by_leave_type_zu from './pages/zu/leave_taken_by_leave_type.html';
import leave_taken_report_af from './pages/af/leave_taken_report.html';
import leave_taken_report_zu from './pages/zu/leave_taken_report.html';
import leave_taken_report_full_af from './pages/af/leave_taken_report_full.html';
import leave_taken_report_full_zu from './pages/zu/leave_taken_report_full.html';
import leave_types_af from './pages/af/leave_types.html';
import leave_types_zu from './pages/zu/leave_types.html';
import mobile_configuration_af from './pages/af/mobile_configuration.html';
import mobile_configuration_zu from './pages/zu/mobile_configuration.html';
import notifications_af from './pages/af/notifications.html';
import notifications_zu from './pages/zu/notifications.html';
import outstanding_data_report_af from './pages/af/outstanding_data_report.html';
import outstanding_data_report_zu from './pages/zu/outstanding_data_report.html';
import page_af from './pages/af/page.html';
import page_zu from './pages/zu/page.html';
import performance_ratings_report_af from './pages/af/performance_ratings_report.html';
import performance_ratings_report_zu from './pages/zu/performance_ratings_report.html';
import preferences_af from './pages/af/preferences.html';
import preferences_zu from './pages/zu/preferences.html';
import ratings_distribution_af from './pages/af/ratings_distribution.html';
import ratings_distribution_zu from './pages/zu/ratings_distribution.html';
import ratings_report_af from './pages/af/ratings_report.html';
import ratings_report_zu from './pages/zu/ratings_report.html';
import release_notes_af from './pages/af/release_notes.html';
import release_notes_zu from './pages/zu/release_notes.html';
import report_backup_managers_af from './pages/af/report_backup_managers.html';
import report_backup_managers_zu from './pages/zu/report_backup_managers.html';
import report_company_hierarchy_af from './pages/af/report_company_hierarchy.html';
import report_company_hierarchy_zu from './pages/zu/report_company_hierarchy.html';
import report_company_orgchart_af from './pages/af/report_company_orgchart.html';
import report_company_orgchart_zu from './pages/zu/report_company_orgchart.html';
import report_department_growth_af from './pages/af/report_department_growth.html';
import report_department_growth_zu from './pages/zu/report_department_growth.html';
import report_employee_hours_af from './pages/af/report_employee_hours.html';
import report_employee_hours_zu from './pages/zu/report_employee_hours.html';
import report_employment_equity_af from './pages/af/report_employment_equity.html';
import report_employment_equity_zu from './pages/zu/report_employment_equity.html';
import report_general_statistics_af from './pages/af/report_general_statistics.html';
import report_general_statistics_zu from './pages/zu/report_general_statistics.html';
import report_leave_af from './pages/af/report_leave.html';
import report_leave_zu from './pages/zu/report_leave.html';
import report_leave_company_af from './pages/af/report_leave_company.html';
import report_leave_company_zu from './pages/zu/report_leave_company.html';
import report_leave_cycles_af from './pages/af/report_leave_cycles.html';
import report_leave_cycles_zu from './pages/zu/report_leave_cycles.html';
import report_leave_department_comparison_af from './pages/af/report_leave_department_comparison.html';
import report_leave_department_comparison_zu from './pages/zu/report_leave_department_comparison.html';
import report_leave_per_day_af from './pages/af/report_leave_per_day.html';
import report_leave_per_day_zu from './pages/zu/report_leave_per_day.html';
import report_leave_per_day_person_af from './pages/af/report_leave_per_day_person.html';
import report_leave_per_day_person_zu from './pages/zu/report_leave_per_day_person.html';
import report_leave_per_department_af from './pages/af/report_leave_per_department.html';
import report_leave_per_department_zu from './pages/zu/report_leave_per_department.html';
import report_leave_per_department_people_af from './pages/af/report_leave_per_department_people.html';
import report_leave_per_department_people_zu from './pages/zu/report_leave_per_department_people.html';
import report_leave_trends_af from './pages/af/report_leave_trends.html';
import report_leave_trends_zu from './pages/zu/report_leave_trends.html';
import report_sick_leave_cycles_af from './pages/af/report_sick_leave_cycles.html';
import report_sick_leave_cycles_zu from './pages/zu/report_sick_leave_cycles.html';
import report_survey_results_af from './pages/af/report_survey_results.html';
import report_survey_results_zu from './pages/zu/report_survey_results.html';
import report_time_logged_af from './pages/af/report_time_logged.html';
import report_time_logged_zu from './pages/zu/report_time_logged.html';
import requisition_af from './pages/af/requisition.html';
import requisition_zu from './pages/zu/requisition.html';
import requisition_configuration_af from './pages/af/requisition_configuration.html';
import requisition_configuration_zu from './pages/zu/requisition_configuration.html';
import requisition_list_af from './pages/af/requisition_list.html';
import requisition_list_zu from './pages/zu/requisition_list.html';
import skillsmatrix_report_af from './pages/af/skillsmatrix_report.html';
import skillsmatrix_report_zu from './pages/zu/skillsmatrix_report.html';
import surveys_af from './pages/af/surveys.html';
import surveys_zu from './pages/zu/surveys.html';
import surveys_setup_af from './pages/af/surveys_setup.html';
import surveys_setup_zu from './pages/zu/surveys_setup.html';
import system_log_af from './pages/af/system_log.html';
import system_log_zu from './pages/zu/system_log.html';
import system_notifications_af from './pages/af/system_notifications.html';
import system_notifications_zu from './pages/zu/system_notifications.html';
import table_page_af from './pages/af/table_page.html';
import table_page_zu from './pages/zu/table_page.html';
import target_vs_actual_time_report_af from './pages/af/target_vs_actual_time_report.html';
import target_vs_actual_time_report_zu from './pages/zu/target_vs_actual_time_report.html';
import termination_reason_af from './pages/af/termination_reason.html';
import termination_reason_zu from './pages/zu/termination_reason.html';
import test_translate_page_af from './pages/af/test_translate_page.html';
import test_translate_page_zu from './pages/zu/test_translate_page.html';
import time_and_attendance_per_employee_report_af from './pages/af/time_and_attendance_per_employee_report.html';
import time_and_attendance_per_employee_report_zu from './pages/zu/time_and_attendance_per_employee_report.html';
import time_approve_af from './pages/af/time_approve.html';
import time_approve_zu from './pages/zu/time_approve.html';
import time_management_setup_af from './pages/af/time_management_setup.html';
import time_management_setup_zu from './pages/zu/time_management_setup.html';
import time_rules_af from './pages/af/time_rules.html';
import time_rules_zu from './pages/zu/time_rules.html';
import time_view_af from './pages/af/time_view.html';
import time_view_zu from './pages/zu/time_view.html';
import what_todo_next_af from './pages/af/what_todo_next.html';
import what_todo_next_zu from './pages/zu/what_todo_next.html';
import wizard_start_af from './pages/af/wizard_start.html';
import wizard_start_zu from './pages/zu/wizard_start.html';
import branches_component_af from './components/af/branches_component.html';
import branches_component_zu from './components/zu/branches_component.html';
import checkbox_dropdown_af from './components/af/checkbox_dropdown.html';
import checkbox_dropdown_zu from './components/zu/checkbox_dropdown.html';
import checkbox_dropdown2_af from './components/af/checkbox_dropdown2.html';
import checkbox_dropdown2_zu from './components/zu/checkbox_dropdown2.html';
import companies_component_af from './components/af/companies_component.html';
import companies_component_zu from './components/zu/companies_component.html';
import company_search_component_af from './components/af/company_search_component.html';
import company_search_component_zu from './components/zu/company_search_component.html';
import contract_type_component_af from './components/af/contract_type_component.html';
import contract_type_component_zu from './components/zu/contract_type_component.html';
import department_search_component_af from './components/af/department_search_component.html';
import department_search_component_zu from './components/zu/department_search_component.html';
import departments_component_af from './components/af/departments_component.html';
import departments_component_zu from './components/zu/departments_component.html';
import employee_fields_component_af from './components/af/employee_fields_component.html';
import employee_fields_component_zu from './components/zu/employee_fields_component.html';
import employee_search_component_af from './components/af/employee_search_component.html';
import employee_search_component_zu from './components/zu/employee_search_component.html';
import employee_view_bursaries_component_af from './components/af/employee_view_bursaries_component.html';
import employee_view_bursaries_component_zu from './components/zu/employee_view_bursaries_component.html';
import employee_view_disciplinary_component_af from './components/af/employee_view_disciplinary_component.html';
import employee_view_disciplinary_component_zu from './components/zu/employee_view_disciplinary_component.html';
import employee_view_document_component_af from './components/af/employee_view_document_component.html';
import employee_view_document_component_zu from './components/zu/employee_view_document_component.html';
import employee_view_employment_component_af from './components/af/employee_view_employment_component.html';
import employee_view_employment_component_zu from './components/zu/employee_view_employment_component.html';
import employee_view_general_component_af from './components/af/employee_view_general_component.html';
import employee_view_general_component_zu from './components/zu/employee_view_general_component.html';
import employee_view_history_component_af from './components/af/employee_view_history_component.html';
import employee_view_history_component_zu from './components/zu/employee_view_history_component.html';
import employee_view_leave_component_af from './components/af/employee_view_leave_component.html';
import employee_view_leave_component_zu from './components/zu/employee_view_leave_component.html';
import employee_view_management_component_af from './components/af/employee_view_management_component.html';
import employee_view_management_component_zu from './components/zu/employee_view_management_component.html';
import employee_view_notes_component_af from './components/af/employee_view_notes_component.html';
import employee_view_notes_component_zu from './components/zu/employee_view_notes_component.html';
import employee_view_performance_management_af from './components/af/employee_view_performance_management.html';
import employee_view_performance_management_zu from './components/zu/employee_view_performance_management.html';
import employee_view_remuneration_component_af from './components/af/employee_view_remuneration_component.html';
import employee_view_remuneration_component_zu from './components/zu/employee_view_remuneration_component.html';
import employee_view_search_component_af from './components/af/employee_view_search_component.html';
import employee_view_search_component_zu from './components/zu/employee_view_search_component.html';
import employee_view_systems_component_af from './components/af/employee_view_systems_component.html';
import employee_view_systems_component_zu from './components/zu/employee_view_systems_component.html';
import events_component_af from './components/af/events_component.html';
import events_component_zu from './components/zu/events_component.html';
import features_roles_component_af from './components/af/features_roles_component.html';
import features_roles_component_zu from './components/zu/features_roles_component.html';
import holidays_component_af from './components/af/holidays_component.html';
import holidays_component_zu from './components/zu/holidays_component.html';
import language_phrase_component_af from './components/af/language_phrase_component.html';
import language_phrase_component_zu from './components/zu/language_phrase_component.html';
import leave_categories_component_af from './components/af/leave_categories_component.html';
import leave_categories_component_zu from './components/zu/leave_categories_component.html';
import leave_types_component_af from './components/af/leave_types_component.html';
import leave_types_component_zu from './components/zu/leave_types_component.html';
import managed_department_search_component_af from './components/af/managed_department_search_component.html';
import managed_department_search_component_zu from './components/zu/managed_department_search_component.html';
import manager_search_component_af from './components/af/manager_search_component.html';
import manager_search_component_zu from './components/zu/manager_search_component.html';
import pagination_template_af from './components/af/pagination_template.html';
import pagination_template_zu from './components/zu/pagination_template.html';
import performance_cycle_search_af from './components/af/performance_cycle_search.html';
import performance_cycle_search_zu from './components/zu/performance_cycle_search.html';
import ps_datetime_picker_af from './components/af/ps_datetime_picker.html';
import ps_datetime_picker_zu from './components/zu/ps_datetime_picker.html';
import ps_navbar_af from './components/af/ps_navbar.html';
import ps_navbar_zu from './components/zu/ps_navbar.html';
import rating_method_search_af from './components/af/rating_method_search.html';
import rating_method_search_zu from './components/zu/rating_method_search.html';
import sample_component_af from './components/af/sample_component.html';
import sample_component_zu from './components/zu/sample_component.html';
import termination_reason_component_af from './components/af/termination_reason_component.html';
import termination_reason_component_zu from './components/zu/termination_reason_component.html';
import add_approval_structure_af from './dialogs/af/add_approval_structure.html';
import add_approval_structure_zu from './dialogs/zu/add_approval_structure.html';
import add_company_obj_af from './dialogs/af/add_company_obj.html';
import add_company_obj_zu from './dialogs/zu/add_company_obj.html';
import add_cycle_step_af from './dialogs/af/add_cycle_step.html';
import add_cycle_step_zu from './dialogs/zu/add_cycle_step.html';
import add_edit_perf_manage_help_af from './dialogs/af/add_edit_perf_manage_help.html';
import add_edit_perf_manage_help_zu from './dialogs/zu/add_edit_perf_manage_help.html';
import add_leave_general_help_af from './dialogs/af/add_leave_general_help.html';
import add_leave_general_help_zu from './dialogs/zu/add_leave_general_help.html';
import add_leave_holiday_help_af from './dialogs/af/add_leave_holiday_help.html';
import add_leave_holiday_help_zu from './dialogs/zu/add_leave_holiday_help.html';
import add_leave_restriction_help_af from './dialogs/af/add_leave_restriction_help.html';
import add_leave_restriction_help_zu from './dialogs/zu/add_leave_restriction_help.html';
import add_leave_roles_help_af from './dialogs/af/add_leave_roles_help.html';
import add_leave_roles_help_zu from './dialogs/zu/add_leave_roles_help.html';
import add_new_holiday_type_af from './dialogs/af/add_new_holiday_type.html';
import add_new_holiday_type_zu from './dialogs/zu/add_new_holiday_type.html';
import add_objective_plan_af from './dialogs/af/add_objective_plan.html';
import add_objective_plan_zu from './dialogs/zu/add_objective_plan.html';
import add_objective_to_plan_af from './dialogs/af/add_objective_to_plan.html';
import add_objective_to_plan_zu from './dialogs/zu/add_objective_to_plan.html';
import add_overtime_rules_af from './dialogs/af/add_overtime_rules.html';
import add_overtime_rules_zu from './dialogs/zu/add_overtime_rules.html';
import add_rating_method_af from './dialogs/af/add_rating_method.html';
import add_rating_method_zu from './dialogs/zu/add_rating_method.html';
import add_time_rules_af from './dialogs/af/add_time_rules.html';
import add_time_rules_zu from './dialogs/zu/add_time_rules.html';
import anonymous_survey_setup_help_af from './dialogs/af/anonymous_survey_setup_help.html';
import anonymous_survey_setup_help_zu from './dialogs/zu/anonymous_survey_setup_help.html';
import approve_leave_help_af from './dialogs/af/approve_leave_help.html';
import approve_leave_help_zu from './dialogs/zu/approve_leave_help.html';
import approve_time_logged_help_af from './dialogs/af/approve_time_logged_help.html';
import approve_time_logged_help_zu from './dialogs/zu/approve_time_logged_help.html';
import approve_users_help_af from './dialogs/af/approve_users_help.html';
import approve_users_help_zu from './dialogs/zu/approve_users_help.html';
import attendance_report_per_department_help_af from './dialogs/af/attendance_report_per_department_help.html';
import attendance_report_per_department_help_zu from './dialogs/zu/attendance_report_per_department_help.html';
import attendance_report_per_employee_help_af from './dialogs/af/attendance_report_per_employee_help.html';
import attendance_report_per_employee_help_zu from './dialogs/zu/attendance_report_per_employee_help.html';
import available_leave_help_af from './dialogs/af/available_leave_help.html';
import available_leave_help_zu from './dialogs/zu/available_leave_help.html';
import backup_manager_report_help_af from './dialogs/af/backup_manager_report_help.html';
import backup_manager_report_help_zu from './dialogs/zu/backup_manager_report_help.html';
import backup_managers_help_af from './dialogs/af/backup_managers_help.html';
import backup_managers_help_zu from './dialogs/zu/backup_managers_help.html';
import branches_help_af from './dialogs/af/branches_help.html';
import branches_help_zu from './dialogs/zu/branches_help.html';
import bursaries_help_af from './dialogs/af/bursaries_help.html';
import bursaries_help_zu from './dialogs/zu/bursaries_help.html';
import cancel_leave_help_af from './dialogs/af/cancel_leave_help.html';
import cancel_leave_help_zu from './dialogs/zu/cancel_leave_help.html';
import check_attendance_report_help_af from './dialogs/af/check_attendance_report_help.html';
import check_attendance_report_help_zu from './dialogs/zu/check_attendance_report_help.html';
import companies_help_af from './dialogs/af/companies_help.html';
import companies_help_zu from './dialogs/zu/companies_help.html';
import company_goals_help_af from './dialogs/af/company_goals_help.html';
import company_goals_help_zu from './dialogs/zu/company_goals_help.html';
import contracts_help_af from './dialogs/af/contracts_help.html';
import contracts_help_zu from './dialogs/zu/contracts_help.html';
import create_cycle_af from './dialogs/af/create_cycle.html';
import create_cycle_zu from './dialogs/zu/create_cycle.html';
import cycle_setup_help_af from './dialogs/af/cycle_setup_help.html';
import cycle_setup_help_zu from './dialogs/zu/cycle_setup_help.html';
import cycle_stage_help_af from './dialogs/af/cycle_stage_help.html';
import cycle_stage_help_zu from './dialogs/zu/cycle_stage_help.html';
import department_growth_report_help_af from './dialogs/af/department_growth_report_help.html';
import department_growth_report_help_zu from './dialogs/zu/department_growth_report_help.html';
import departments_help_af from './dialogs/af/departments_help.html';
import departments_help_zu from './dialogs/zu/departments_help.html';
import diversity_statistics_report_help_af from './dialogs/af/diversity_statistics_report_help.html';
import diversity_statistics_report_help_zu from './dialogs/zu/diversity_statistics_report_help.html';
import documents_help_af from './dialogs/af/documents_help.html';
import documents_help_zu from './dialogs/zu/documents_help.html';
import edit_document_af from './dialogs/af/edit_document.html';
import edit_document_zu from './dialogs/zu/edit_document.html';
import edit_project_af from './dialogs/af/edit_project.html';
import edit_project_zu from './dialogs/zu/edit_project.html';
import edit_transaction_type_af from './dialogs/af/edit_transaction_type.html';
import edit_transaction_type_zu from './dialogs/zu/edit_transaction_type.html';
import education_help_af from './dialogs/af/education_help.html';
import education_help_zu from './dialogs/zu/education_help.html';
import eea_report_help_af from './dialogs/af/eea_report_help.html';
import eea_report_help_zu from './dialogs/zu/eea_report_help.html';
import employee_add_disciplinary_af from './dialogs/af/employee_add_disciplinary.html';
import employee_add_disciplinary_zu from './dialogs/zu/employee_add_disciplinary.html';
import employee_add_field_af from './dialogs/af/employee_add_field.html';
import employee_add_field_zu from './dialogs/zu/employee_add_field.html';
import employee_add_linked_leave_af from './dialogs/af/employee_add_linked_leave.html';
import employee_add_linked_leave_zu from './dialogs/zu/employee_add_linked_leave.html';
import employee_add_linked_leave_by_category_af from './dialogs/af/employee_add_linked_leave_by_category.html';
import employee_add_linked_leave_by_category_zu from './dialogs/zu/employee_add_linked_leave_by_category.html';
import employee_add_manager_department_af from './dialogs/af/employee_add_manager_department.html';
import employee_add_manager_department_zu from './dialogs/zu/employee_add_manager_department.html';
import employee_attendance_information_help_af from './dialogs/af/employee_attendance_information_help.html';
import employee_attendance_information_help_zu from './dialogs/zu/employee_attendance_information_help.html';
import employee_category_add_af from './dialogs/af/employee_category_add.html';
import employee_category_add_zu from './dialogs/zu/employee_category_add.html';
import employee_convert_linked_leave_type_af from './dialogs/af/employee_convert_linked_leave_type.html';
import employee_convert_linked_leave_type_zu from './dialogs/zu/employee_convert_linked_leave_type.html';
import employee_details_help_af from './dialogs/af/employee_details_help.html';
import employee_details_help_zu from './dialogs/zu/employee_details_help.html';
import employee_document_count_report_help_af from './dialogs/af/employee_document_count_report_help.html';
import employee_document_count_report_help_zu from './dialogs/zu/employee_document_count_report_help.html';
import employee_document_reject_af from './dialogs/af/employee_document_reject.html';
import employee_document_reject_zu from './dialogs/zu/employee_document_reject.html';
import employee_documents_help_af from './dialogs/af/employee_documents_help.html';
import employee_documents_help_zu from './dialogs/zu/employee_documents_help.html';
import employee_employment_listing_report_help_af from './dialogs/af/employee_employment_listing_report_help.html';
import employee_employment_listing_report_help_zu from './dialogs/zu/employee_employment_listing_report_help.html';
import employee_end_linked_leave_af from './dialogs/af/employee_end_linked_leave.html';
import employee_end_linked_leave_zu from './dialogs/zu/employee_end_linked_leave.html';
import employee_field_report_help_af from './dialogs/af/employee_field_report_help.html';
import employee_field_report_help_zu from './dialogs/zu/employee_field_report_help.html';
import employee_fields_help_af from './dialogs/af/employee_fields_help.html';
import employee_fields_help_zu from './dialogs/zu/employee_fields_help.html';
import employee_groups_add_af from './dialogs/af/employee_groups_add.html';
import employee_groups_add_zu from './dialogs/zu/employee_groups_add.html';
import employee_groups_help_af from './dialogs/af/employee_groups_help.html';
import employee_groups_help_zu from './dialogs/zu/employee_groups_help.html';
import employee_history_help_af from './dialogs/af/employee_history_help.html';
import employee_history_help_zu from './dialogs/zu/employee_history_help.html';
import employee_import_help_af from './dialogs/af/employee_import_help.html';
import employee_import_help_zu from './dialogs/zu/employee_import_help.html';
import employee_leave_coming_up_help_af from './dialogs/af/employee_leave_coming_up_help.html';
import employee_leave_coming_up_help_zu from './dialogs/zu/employee_leave_coming_up_help.html';
import employee_leave_entry_af from './dialogs/af/employee_leave_entry.html';
import employee_leave_entry_zu from './dialogs/zu/employee_leave_entry.html';
import employee_resign_af from './dialogs/af/employee_resign.html';
import employee_resign_zu from './dialogs/zu/employee_resign.html';
import employee_upload_document_af from './dialogs/af/employee_upload_document.html';
import employee_upload_document_zu from './dialogs/zu/employee_upload_document.html';
import employee_upload_leave_document_af from './dialogs/af/employee_upload_leave_document.html';
import employee_upload_leave_document_zu from './dialogs/zu/employee_upload_leave_document.html';
import employee_upload_payroll_document_af from './dialogs/af/employee_upload_payroll_document.html';
import employee_upload_payroll_document_zu from './dialogs/zu/employee_upload_payroll_document.html';
import employee_upload_photo_af from './dialogs/af/employee_upload_photo.html';
import employee_upload_photo_zu from './dialogs/zu/employee_upload_photo.html';
import employees_active_per_department_count_help_af from './dialogs/af/employees_active_per_department_count_help.html';
import employees_active_per_department_count_help_zu from './dialogs/zu/employees_active_per_department_count_help.html';
import employees_currently_on_leave_help_af from './dialogs/af/employees_currently_on_leave_help.html';
import employees_currently_on_leave_help_zu from './dialogs/zu/employees_currently_on_leave_help.html';
import employees_taking_leave_per_department_count_help_af from './dialogs/af/employees_taking_leave_per_department_count_help.html';
import employees_taking_leave_per_department_count_help_zu from './dialogs/zu/employees_taking_leave_per_department_count_help.html';
import employees_with_roles_help_af from './dialogs/af/employees_with_roles_help.html';
import employees_with_roles_help_zu from './dialogs/zu/employees_with_roles_help.html';
import employment_listing_help_af from './dialogs/af/employment_listing_help.html';
import employment_listing_help_zu from './dialogs/zu/employment_listing_help.html';
import events_help_af from './dialogs/af/events_help.html';
import events_help_zu from './dialogs/zu/events_help.html';
import feature_roles_help_af from './dialogs/af/feature_roles_help.html';
import feature_roles_help_zu from './dialogs/zu/feature_roles_help.html';
import general_documents_help_af from './dialogs/af/general_documents_help.html';
import general_documents_help_zu from './dialogs/zu/general_documents_help.html';
import holidays_help_af from './dialogs/af/holidays_help.html';
import holidays_help_zu from './dialogs/zu/holidays_help.html';
import import_employees_af from './dialogs/af/import_employees.html';
import import_employees_zu from './dialogs/zu/import_employees.html';
import import_holiday_af from './dialogs/af/import_holiday.html';
import import_holiday_zu from './dialogs/zu/import_holiday.html';
import import_time_log_help_af from './dialogs/af/import_time_log_help.html';
import import_time_log_help_zu from './dialogs/zu/import_time_log_help.html';
import import_time_logged_af from './dialogs/af/import_time_logged.html';
import import_time_logged_zu from './dialogs/zu/import_time_logged.html';
import insert_leave_entry_af from './dialogs/af/insert_leave_entry.html';
import insert_leave_entry_zu from './dialogs/zu/insert_leave_entry.html';
import leave_adjustments_help_af from './dialogs/af/leave_adjustments_help.html';
import leave_adjustments_help_zu from './dialogs/zu/leave_adjustments_help.html';
import leave_auto_link_help_af from './dialogs/af/leave_auto_link_help.html';
import leave_auto_link_help_zu from './dialogs/zu/leave_auto_link_help.html';
import leave_available_by_company_help_af from './dialogs/af/leave_available_by_company_help.html';
import leave_available_by_company_help_zu from './dialogs/zu/leave_available_by_company_help.html';
import leave_cancellation_reject_af from './dialogs/af/leave_cancellation_reject.html';
import leave_cancellation_reject_zu from './dialogs/zu/leave_cancellation_reject.html';
import leave_categories_help_af from './dialogs/af/leave_categories_help.html';
import leave_categories_help_zu from './dialogs/zu/leave_categories_help.html';
import leave_cost_per_department_help_af from './dialogs/af/leave_cost_per_department_help.html';
import leave_cost_per_department_help_zu from './dialogs/zu/leave_cost_per_department_help.html';
import leave_earned_help_af from './dialogs/af/leave_earned_help.html';
import leave_earned_help_zu from './dialogs/zu/leave_earned_help.html';
import leave_reject_af from './dialogs/af/leave_reject.html';
import leave_reject_zu from './dialogs/zu/leave_reject.html';
import leave_restriction_rule_af from './dialogs/af/leave_restriction_rule.html';
import leave_restriction_rule_zu from './dialogs/zu/leave_restriction_rule.html';
import leave_restriction_rule_leave_type_edit_af from './dialogs/af/leave_restriction_rule_leave_type_edit.html';
import leave_restriction_rule_leave_type_edit_zu from './dialogs/zu/leave_restriction_rule_leave_type_edit.html';
import leave_restriction_rules_af from './dialogs/af/leave_restriction_rules.html';
import leave_restriction_rules_zu from './dialogs/zu/leave_restriction_rules.html';
import leave_summary_help_af from './dialogs/af/leave_summary_help.html';
import leave_summary_help_zu from './dialogs/zu/leave_summary_help.html';
import leave_taken_breakdown_by_leave_entry_help_af from './dialogs/af/leave_taken_breakdown_by_leave_entry_help.html';
import leave_taken_breakdown_by_leave_entry_help_zu from './dialogs/zu/leave_taken_breakdown_by_leave_entry_help.html';
import leave_taken_by_leave_type_help_af from './dialogs/af/leave_taken_by_leave_type_help.html';
import leave_taken_by_leave_type_help_zu from './dialogs/zu/leave_taken_by_leave_type_help.html';
import leave_taken_comparison_between_departments_help_af from './dialogs/af/leave_taken_comparison_between_departments_help.html';
import leave_taken_comparison_between_departments_help_zu from './dialogs/zu/leave_taken_comparison_between_departments_help.html';
import leave_taken_help_af from './dialogs/af/leave_taken_help.html';
import leave_taken_help_zu from './dialogs/zu/leave_taken_help.html';
import leave_taken_per_day_count_help_af from './dialogs/af/leave_taken_per_day_count_help.html';
import leave_taken_per_day_count_help_zu from './dialogs/zu/leave_taken_per_day_count_help.html';
import leave_taken_report_help_af from './dialogs/af/leave_taken_report_help.html';
import leave_taken_report_help_zu from './dialogs/zu/leave_taken_report_help.html';
import leave_trends_help_af from './dialogs/af/leave_trends_help.html';
import leave_trends_help_zu from './dialogs/zu/leave_trends_help.html';
import leave_types_add_af from './dialogs/af/leave_types_add.html';
import leave_types_add_zu from './dialogs/zu/leave_types_add.html';
import leave_types_help_af from './dialogs/af/leave_types_help.html';
import leave_types_help_zu from './dialogs/zu/leave_types_help.html';
import linked_company_objective_af from './dialogs/af/linked_company_objective.html';
import linked_company_objective_zu from './dialogs/zu/linked_company_objective.html';
import log_time_af from './dialogs/af/log_time.html';
import log_time_zu from './dialogs/zu/log_time.html';
import log_time_employee_af from './dialogs/af/log_time_employee.html';
import log_time_employee_zu from './dialogs/zu/log_time_employee.html';
import managed_departments_help_af from './dialogs/af/managed_departments_help.html';
import managed_departments_help_zu from './dialogs/zu/managed_departments_help.html';
import managed_employees_help_af from './dialogs/af/managed_employees_help.html';
import managed_employees_help_zu from './dialogs/zu/managed_employees_help.html';
import manager_subordinate_structure_help_af from './dialogs/af/manager_subordinate_structure_help.html';
import manager_subordinate_structure_help_zu from './dialogs/zu/manager_subordinate_structure_help.html';
import managers_help_af from './dialogs/af/managers_help.html';
import managers_help_zu from './dialogs/zu/managers_help.html';
import mobile_configuration_add_image_af from './dialogs/af/mobile_configuration_add_image.html';
import mobile_configuration_add_image_zu from './dialogs/zu/mobile_configuration_add_image.html';
import mobile_configuration_help_af from './dialogs/af/mobile_configuration_help.html';
import mobile_configuration_help_zu from './dialogs/zu/mobile_configuration_help.html';
import notes_help_af from './dialogs/af/notes_help.html';
import notes_help_zu from './dialogs/zu/notes_help.html';
import objective_details_help_af from './dialogs/af/objective_details_help.html';
import objective_details_help_zu from './dialogs/zu/objective_details_help.html';
import objective_measures_help_af from './dialogs/af/objective_measures_help.html';
import objective_measures_help_zu from './dialogs/zu/objective_measures_help.html';
import objectives_summary_help_af from './dialogs/af/objectives_summary_help.html';
import objectives_summary_help_zu from './dialogs/zu/objectives_summary_help.html';
import open_notification_dialog_af from './dialogs/af/open_notification_dialog.html';
import open_notification_dialog_zu from './dialogs/zu/open_notification_dialog.html';
import outstanding_data_help_af from './dialogs/af/outstanding_data_help.html';
import outstanding_data_help_zu from './dialogs/zu/outstanding_data_help.html';
import performance_cycle_ratings_help_af from './dialogs/af/performance_cycle_ratings_help.html';
import performance_cycle_ratings_help_zu from './dialogs/zu/performance_cycle_ratings_help.html';
import promote_demote_help_af from './dialogs/af/promote_demote_help.html';
import promote_demote_help_zu from './dialogs/zu/promote_demote_help.html';
import rating_distribution_help_af from './dialogs/af/rating_distribution_help.html';
import rating_distribution_help_zu from './dialogs/zu/rating_distribution_help.html';
import rating_methods_help_af from './dialogs/af/rating_methods_help.html';
import rating_methods_help_zu from './dialogs/zu/rating_methods_help.html';
import register_dialog_af from './dialogs/af/register_dialog.html';
import register_dialog_zu from './dialogs/zu/register_dialog.html';
import reject_users_af from './dialogs/af/reject_users.html';
import reject_users_zu from './dialogs/zu/reject_users.html';
import report_company_leave_available_adjust_and_refresh_af from './dialogs/af/report_company_leave_available_adjust_and_refresh.html';
import report_company_leave_available_adjust_and_refresh_zu from './dialogs/zu/report_company_leave_available_adjust_and_refresh.html';
import report_leave_taken_settings_af from './dialogs/af/report_leave_taken_settings.html';
import report_leave_taken_settings_zu from './dialogs/zu/report_leave_taken_settings.html';
import report_time_logged_help_af from './dialogs/af/report_time_logged_help.html';
import report_time_logged_help_zu from './dialogs/zu/report_time_logged_help.html';
import requisition_configuration_add_image_af from './dialogs/af/requisition_configuration_add_image.html';
import requisition_configuration_add_image_zu from './dialogs/zu/requisition_configuration_add_image.html';
import requisition_configuration_help_af from './dialogs/af/requisition_configuration_help.html';
import requisition_configuration_help_zu from './dialogs/zu/requisition_configuration_help.html';
import setup_overtime_rules_help_af from './dialogs/af/setup_overtime_rules_help.html';
import setup_overtime_rules_help_zu from './dialogs/zu/setup_overtime_rules_help.html';
import setup_time_rules_help_af from './dialogs/af/setup_time_rules_help.html';
import setup_time_rules_help_zu from './dialogs/zu/setup_time_rules_help.html';
import sick_leave_cycles_information_help_af from './dialogs/af/sick_leave_cycles_information_help.html';
import sick_leave_cycles_information_help_zu from './dialogs/zu/sick_leave_cycles_information_help.html';
import skill_competency_data_help_af from './dialogs/af/skill_competency_data_help.html';
import skill_competency_data_help_zu from './dialogs/zu/skill_competency_data_help.html';
import skills_competency_help_af from './dialogs/af/skills_competency_help.html';
import skills_competency_help_zu from './dialogs/zu/skills_competency_help.html';
import survey_results_help_af from './dialogs/af/survey_results_help.html';
import survey_results_help_zu from './dialogs/zu/survey_results_help.html';
import survey_segments_af from './dialogs/af/survey_segments.html';
import survey_segments_zu from './dialogs/zu/survey_segments.html';
import surveys_setup_add_af from './dialogs/af/surveys_setup_add.html';
import surveys_setup_add_zu from './dialogs/zu/surveys_setup_add.html';
import surveys_setup_help_af from './dialogs/af/surveys_setup_help.html';
import surveys_setup_help_zu from './dialogs/zu/surveys_setup_help.html';
import surveys_setup_questions_add_af from './dialogs/af/surveys_setup_questions_add.html';
import surveys_setup_questions_add_zu from './dialogs/zu/surveys_setup_questions_add.html';
import system_notifications_add_af from './dialogs/af/system_notifications_add.html';
import system_notifications_add_zu from './dialogs/zu/system_notifications_add.html';
import system_notifications_help_af from './dialogs/af/system_notifications_help.html';
import system_notifications_help_zu from './dialogs/zu/system_notifications_help.html';
import table_layout_af from './dialogs/af/table_layout.html';
import table_layout_zu from './dialogs/zu/table_layout.html';
import time_logged_reject_af from './dialogs/af/time_logged_reject.html';
import time_logged_reject_zu from './dialogs/zu/time_logged_reject.html';
import time_management_setup_help_af from './dialogs/af/time_management_setup_help.html';
import time_management_setup_help_zu from './dialogs/zu/time_management_setup_help.html';
import time_view_help_af from './dialogs/af/time_view_help.html';
import time_view_help_zu from './dialogs/zu/time_view_help.html';
import upcoming_birthdays_help_af from './dialogs/af/upcoming_birthdays_help.html';
import upcoming_birthdays_help_zu from './dialogs/zu/upcoming_birthdays_help.html';
import upload_general_document_af from './dialogs/af/upload_general_document.html';
import upload_general_document_zu from './dialogs/zu/upload_general_document.html';
import view_perf_objective_plan_af from './dialogs/af/view_perf_objective_plan.html';
import view_perf_objective_plan_zu from './dialogs/zu/view_perf_objective_plan.html';
import wizard_companies_af from './dialogs/af/wizard_companies.html';
import wizard_companies_zu from './dialogs/zu/wizard_companies.html';
import wizard_departments_af from './dialogs/af/wizard_departments.html';
import wizard_departments_zu from './dialogs/zu/wizard_departments.html';
import wizard_employee_create_af from './dialogs/af/wizard_employee_create.html';
import wizard_employee_create_zu from './dialogs/zu/wizard_employee_create.html';
import wizard_employee_fields_af from './dialogs/af/wizard_employee_fields.html';
import wizard_employee_fields_zu from './dialogs/zu/wizard_employee_fields.html';
import wizard_finish_basic_af from './dialogs/af/wizard_finish_basic.html';
import wizard_finish_basic_zu from './dialogs/zu/wizard_finish_basic.html';
import wizard_finsh_af from './dialogs/af/wizard_finsh.html';
import wizard_finsh_zu from './dialogs/zu/wizard_finsh.html';
import wizard_holiday_setup_af from './dialogs/af/wizard_holiday_setup.html';
import wizard_holiday_setup_zu from './dialogs/zu/wizard_holiday_setup.html';
import wizard_holidays_af from './dialogs/af/wizard_holidays.html';
import wizard_holidays_zu from './dialogs/zu/wizard_holidays.html';
import wizard_leave_setup_cycle_af from './dialogs/af/wizard_leave_setup_cycle.html';
import wizard_leave_setup_cycle_zu from './dialogs/zu/wizard_leave_setup_cycle.html';
import wizard_leave_setup_description_af from './dialogs/af/wizard_leave_setup_description.html';
import wizard_leave_setup_description_zu from './dialogs/zu/wizard_leave_setup_description.html';
import wizard_leave_setup_employees_af from './dialogs/af/wizard_leave_setup_employees.html';
import wizard_leave_setup_employees_zu from './dialogs/zu/wizard_leave_setup_employees.html';
import wizard_leave_setup_holidays_af from './dialogs/af/wizard_leave_setup_holidays.html';
import wizard_leave_setup_holidays_zu from './dialogs/zu/wizard_leave_setup_holidays.html';
import wizard_leave_setup_overview_af from './dialogs/af/wizard_leave_setup_overview.html';
import wizard_leave_setup_overview_zu from './dialogs/zu/wizard_leave_setup_overview.html';
import wizard_leave_setup_restrictions_af from './dialogs/af/wizard_leave_setup_restrictions.html';
import wizard_leave_setup_restrictions_zu from './dialogs/zu/wizard_leave_setup_restrictions.html';
import wizard_leave_setup_roles_af from './dialogs/af/wizard_leave_setup_roles.html';
import wizard_leave_setup_roles_zu from './dialogs/zu/wizard_leave_setup_roles.html';
import wizard_leave_types_af from './dialogs/af/wizard_leave_types.html';
import wizard_leave_types_zu from './dialogs/zu/wizard_leave_types.html';
 
 
export default {
'translation/about': {
'af' : about_af,
'zu' : about_zu
},
'translation/access_denied': {
'af' : access_denied_af,
'zu' : access_denied_zu
},
'translation/add_edit_performance_management': {
'af' : add_edit_performance_management_af,
'zu' : add_edit_performance_management_zu
},
'translation/anonymous_survey': {
'af' : anonymous_survey_af,
'zu' : anonymous_survey_zu
},
'translation/approve_documents': {
'af' : approve_documents_af,
'zu' : approve_documents_zu
},
'translation/approve_leave': {
'af' : approve_leave_af,
'zu' : approve_leave_zu
},
'translation/approve_users': {
'af' : approve_users_af,
'zu' : approve_users_zu
},
'translation/birthday_report': {
'af' : birthday_report_af,
'zu' : birthday_report_zu
},
'translation/branches': {
'af' : branches_af,
'zu' : branches_zu
},
'translation/calendar': {
'af' : calendar_af,
'zu' : calendar_zu
},
'translation/companies': {
'af' : companies_af,
'zu' : companies_zu
},
'translation/contract_type': {
'af' : contract_type_af,
'zu' : contract_type_zu
},
'translation/departments': {
'af' : departments_af,
'zu' : departments_zu
},
'translation/document_categories': {
'af' : document_categories_af,
'zu' : document_categories_zu
},
'translation/documents': {
'af' : documents_af,
'zu' : documents_zu
},
'translation/employee_attendance_report': {
'af' : employee_attendance_report_af,
'zu' : employee_attendance_report_zu
},
'translation/employee_count_report': {
'af' : employee_count_report_af,
'zu' : employee_count_report_zu
},
'translation/employee_create': {
'af' : employee_create_af,
'zu' : employee_create_zu
},
'translation/employee_dashboard': {
'af' : employee_dashboard_af,
'zu' : employee_dashboard_zu
},
'translation/employee_disciplinary_report': {
'af' : employee_disciplinary_report_af,
'zu' : employee_disciplinary_report_zu
},
'translation/employee_document_count_report': {
'af' : employee_document_count_report_af,
'zu' : employee_document_count_report_zu
},
'translation/employee_employment_listing_report': {
'af' : employee_employment_listing_report_af,
'zu' : employee_employment_listing_report_zu
},
'translation/employee_field_report': {
'af' : employee_field_report_af,
'zu' : employee_field_report_zu
},
'translation/employee_fields': {
'af' : employee_fields_af,
'zu' : employee_fields_zu
},
'translation/employee_groups': {
'af' : employee_groups_af,
'zu' : employee_groups_zu
},
'translation/employee_leave': {
'af' : employee_leave_af,
'zu' : employee_leave_zu
},
'translation/employee_list_new': {
'af' : employee_list_new_af,
'zu' : employee_list_new_zu
},
'translation/employee_notifications': {
'af' : employee_notifications_af,
'zu' : employee_notifications_zu
},
'translation/employee_redirect': {
'af' : employee_redirect_af,
'zu' : employee_redirect_zu
},
'translation/employee_role_list': {
'af' : employee_role_list_af,
'zu' : employee_role_list_zu
},
'translation/employee_search': {
'af' : employee_search_af,
'zu' : employee_search_zu
},
'translation/employee_view': {
'af' : employee_view_af,
'zu' : employee_view_zu
},
'translation/employees_currently_on_leave_report': {
'af' : employees_currently_on_leave_report_af,
'zu' : employees_currently_on_leave_report_zu
},
'translation/employees_future_leave_report': {
'af' : employees_future_leave_report_af,
'zu' : employees_future_leave_report_zu
},
'translation/events': {
'af' : events_af,
'zu' : events_zu
},
'translation/faq': {
'af' : faq_af,
'zu' : faq_zu
},
'translation/features_roles': {
'af' : features_roles_af,
'zu' : features_roles_zu
},
'translation/general_document_categories': {
'af' : general_document_categories_af,
'zu' : general_document_categories_zu
},
'translation/holidays': {
'af' : holidays_af,
'zu' : holidays_zu
},
'translation/leave_cancellation_request': {
'af' : leave_cancellation_request_af,
'zu' : leave_cancellation_request_zu
},
'translation/leave_categories': {
'af' : leave_categories_af,
'zu' : leave_categories_zu
},
'translation/leave_rules': {
'af' : leave_rules_af,
'zu' : leave_rules_zu
},
'translation/leave_taken_by_leave_type': {
'af' : leave_taken_by_leave_type_af,
'zu' : leave_taken_by_leave_type_zu
},
'translation/leave_taken_report': {
'af' : leave_taken_report_af,
'zu' : leave_taken_report_zu
},
'translation/leave_taken_report_full': {
'af' : leave_taken_report_full_af,
'zu' : leave_taken_report_full_zu
},
'translation/leave_types': {
'af' : leave_types_af,
'zu' : leave_types_zu
},
'translation/mobile_configuration': {
'af' : mobile_configuration_af,
'zu' : mobile_configuration_zu
},
'translation/notifications': {
'af' : notifications_af,
'zu' : notifications_zu
},
'translation/outstanding_data_report': {
'af' : outstanding_data_report_af,
'zu' : outstanding_data_report_zu
},
'translation/page': {
'af' : page_af,
'zu' : page_zu
},
'translation/performance_ratings_report': {
'af' : performance_ratings_report_af,
'zu' : performance_ratings_report_zu
},
'translation/preferences': {
'af' : preferences_af,
'zu' : preferences_zu
},
'translation/ratings_distribution': {
'af' : ratings_distribution_af,
'zu' : ratings_distribution_zu
},
'translation/ratings_report': {
'af' : ratings_report_af,
'zu' : ratings_report_zu
},
'translation/release_notes': {
'af' : release_notes_af,
'zu' : release_notes_zu
},
'translation/report_backup_managers': {
'af' : report_backup_managers_af,
'zu' : report_backup_managers_zu
},
'translation/report_company_hierarchy': {
'af' : report_company_hierarchy_af,
'zu' : report_company_hierarchy_zu
},
'translation/report_company_orgchart': {
'af' : report_company_orgchart_af,
'zu' : report_company_orgchart_zu
},
'translation/report_department_growth': {
'af' : report_department_growth_af,
'zu' : report_department_growth_zu
},
'translation/report_employee_hours': {
'af' : report_employee_hours_af,
'zu' : report_employee_hours_zu
},
'translation/report_employment_equity': {
'af' : report_employment_equity_af,
'zu' : report_employment_equity_zu
},
'translation/report_general_statistics': {
'af' : report_general_statistics_af,
'zu' : report_general_statistics_zu
},
'translation/report_leave': {
'af' : report_leave_af,
'zu' : report_leave_zu
},
'translation/report_leave_company': {
'af' : report_leave_company_af,
'zu' : report_leave_company_zu
},
'translation/report_leave_cycles': {
'af' : report_leave_cycles_af,
'zu' : report_leave_cycles_zu
},
'translation/report_leave_department_comparison': {
'af' : report_leave_department_comparison_af,
'zu' : report_leave_department_comparison_zu
},
'translation/report_leave_per_day': {
'af' : report_leave_per_day_af,
'zu' : report_leave_per_day_zu
},
'translation/report_leave_per_day_person': {
'af' : report_leave_per_day_person_af,
'zu' : report_leave_per_day_person_zu
},
'translation/report_leave_per_department': {
'af' : report_leave_per_department_af,
'zu' : report_leave_per_department_zu
},
'translation/report_leave_per_department_people': {
'af' : report_leave_per_department_people_af,
'zu' : report_leave_per_department_people_zu
},
'translation/report_leave_trends': {
'af' : report_leave_trends_af,
'zu' : report_leave_trends_zu
},
'translation/report_sick_leave_cycles': {
'af' : report_sick_leave_cycles_af,
'zu' : report_sick_leave_cycles_zu
},
'translation/report_survey_results': {
'af' : report_survey_results_af,
'zu' : report_survey_results_zu
},
'translation/report_time_logged': {
'af' : report_time_logged_af,
'zu' : report_time_logged_zu
},
'translation/requisition': {
'af' : requisition_af,
'zu' : requisition_zu
},
'translation/requisition_configuration': {
'af' : requisition_configuration_af,
'zu' : requisition_configuration_zu
},
'translation/requisition_list': {
'af' : requisition_list_af,
'zu' : requisition_list_zu
},
'translation/skillsmatrix_report': {
'af' : skillsmatrix_report_af,
'zu' : skillsmatrix_report_zu
},
'translation/surveys': {
'af' : surveys_af,
'zu' : surveys_zu
},
'translation/surveys_setup': {
'af' : surveys_setup_af,
'zu' : surveys_setup_zu
},
'translation/system_log': {
'af' : system_log_af,
'zu' : system_log_zu
},
'translation/system_notifications': {
'af' : system_notifications_af,
'zu' : system_notifications_zu
},
'translation/table_page': {
'af' : table_page_af,
'zu' : table_page_zu
},
'translation/target_vs_actual_time_report': {
'af' : target_vs_actual_time_report_af,
'zu' : target_vs_actual_time_report_zu
},
'translation/termination_reason': {
'af' : termination_reason_af,
'zu' : termination_reason_zu
},
'translation/test_translate_page': {
'af' : test_translate_page_af,
'zu' : test_translate_page_zu
},
'translation/time_and_attendance_per_employee_report': {
'af' : time_and_attendance_per_employee_report_af,
'zu' : time_and_attendance_per_employee_report_zu
},
'translation/time_approve': {
'af' : time_approve_af,
'zu' : time_approve_zu
},
'translation/time_management_setup': {
'af' : time_management_setup_af,
'zu' : time_management_setup_zu
},
'translation/time_rules': {
'af' : time_rules_af,
'zu' : time_rules_zu
},
'translation/time_view': {
'af' : time_view_af,
'zu' : time_view_zu
},
'translation/what_todo_next': {
'af' : what_todo_next_af,
'zu' : what_todo_next_zu
},
'translation/wizard_start': {
'af' : wizard_start_af,
'zu' : wizard_start_zu
},
'translation/components/branches_component': {
'af' : branches_component_af,
'zu' : branches_component_zu
},
'translation/components/checkbox_dropdown': {
'af' : checkbox_dropdown_af,
'zu' : checkbox_dropdown_zu
},
'translation/components/checkbox_dropdown2': {
'af' : checkbox_dropdown2_af,
'zu' : checkbox_dropdown2_zu
},
'translation/components/companies_component': {
'af' : companies_component_af,
'zu' : companies_component_zu
},
'translation/components/company_search_component': {
'af' : company_search_component_af,
'zu' : company_search_component_zu
},
'translation/components/contract_type_component': {
'af' : contract_type_component_af,
'zu' : contract_type_component_zu
},
'translation/components/department_search_component': {
'af' : department_search_component_af,
'zu' : department_search_component_zu
},
'translation/components/departments_component': {
'af' : departments_component_af,
'zu' : departments_component_zu
},
'translation/components/employee_fields_component': {
'af' : employee_fields_component_af,
'zu' : employee_fields_component_zu
},
'translation/components/employee_search_component': {
'af' : employee_search_component_af,
'zu' : employee_search_component_zu
},
'translation/components/employee_view_bursaries_component': {
'af' : employee_view_bursaries_component_af,
'zu' : employee_view_bursaries_component_zu
},
'translation/components/employee_view_disciplinary_component': {
'af' : employee_view_disciplinary_component_af,
'zu' : employee_view_disciplinary_component_zu
},
'translation/components/employee_view_document_component': {
'af' : employee_view_document_component_af,
'zu' : employee_view_document_component_zu
},
'translation/components/employee_view_employment_component': {
'af' : employee_view_employment_component_af,
'zu' : employee_view_employment_component_zu
},
'translation/components/employee_view_general_component': {
'af' : employee_view_general_component_af,
'zu' : employee_view_general_component_zu
},
'translation/components/employee_view_history_component': {
'af' : employee_view_history_component_af,
'zu' : employee_view_history_component_zu
},
'translation/components/employee_view_leave_component': {
'af' : employee_view_leave_component_af,
'zu' : employee_view_leave_component_zu
},
'translation/components/employee_view_management_component': {
'af' : employee_view_management_component_af,
'zu' : employee_view_management_component_zu
},
'translation/components/employee_view_notes_component': {
'af' : employee_view_notes_component_af,
'zu' : employee_view_notes_component_zu
},
'translation/components/employee_view_performance_management': {
'af' : employee_view_performance_management_af,
'zu' : employee_view_performance_management_zu
},
'translation/components/employee_view_remuneration_component': {
'af' : employee_view_remuneration_component_af,
'zu' : employee_view_remuneration_component_zu
},
'translation/components/employee_view_search_component': {
'af' : employee_view_search_component_af,
'zu' : employee_view_search_component_zu
},
'translation/components/employee_view_systems_component': {
'af' : employee_view_systems_component_af,
'zu' : employee_view_systems_component_zu
},
'translation/components/events_component': {
'af' : events_component_af,
'zu' : events_component_zu
},
'translation/components/features_roles_component': {
'af' : features_roles_component_af,
'zu' : features_roles_component_zu
},
'translation/components/holidays_component': {
'af' : holidays_component_af,
'zu' : holidays_component_zu
},
'translation/components/language_phrase_component': {
'af' : language_phrase_component_af,
'zu' : language_phrase_component_zu
},
'translation/components/leave_categories_component': {
'af' : leave_categories_component_af,
'zu' : leave_categories_component_zu
},
'translation/components/leave_types_component': {
'af' : leave_types_component_af,
'zu' : leave_types_component_zu
},
'translation/components/managed_department_search_component': {
'af' : managed_department_search_component_af,
'zu' : managed_department_search_component_zu
},
'translation/components/manager_search_component': {
'af' : manager_search_component_af,
'zu' : manager_search_component_zu
},
'translation/components/pagination_template': {
'af' : pagination_template_af,
'zu' : pagination_template_zu
},
'translation/components/performance_cycle_search': {
'af' : performance_cycle_search_af,
'zu' : performance_cycle_search_zu
},
'translation/components/ps_datetime_picker': {
'af' : ps_datetime_picker_af,
'zu' : ps_datetime_picker_zu
},
'translation/components/ps_navbar': {
'af' : ps_navbar_af,
'zu' : ps_navbar_zu
},
'translation/components/rating_method_search': {
'af' : rating_method_search_af,
'zu' : rating_method_search_zu
},
'translation/components/sample_component': {
'af' : sample_component_af,
'zu' : sample_component_zu
},
'translation/components/termination_reason_component': {
'af' : termination_reason_component_af,
'zu' : termination_reason_component_zu
},
'translation/dialogs/add_approval_structure': {
'af' : add_approval_structure_af,
'zu' : add_approval_structure_zu
},
'translation/dialogs/add_company_obj': {
'af' : add_company_obj_af,
'zu' : add_company_obj_zu
},
'translation/dialogs/add_cycle_step': {
'af' : add_cycle_step_af,
'zu' : add_cycle_step_zu
},
'translation/dialogs/add_edit_perf_manage_help': {
'af' : add_edit_perf_manage_help_af,
'zu' : add_edit_perf_manage_help_zu
},
'translation/dialogs/add_leave_general_help': {
'af' : add_leave_general_help_af,
'zu' : add_leave_general_help_zu
},
'translation/dialogs/add_leave_holiday_help': {
'af' : add_leave_holiday_help_af,
'zu' : add_leave_holiday_help_zu
},
'translation/dialogs/add_leave_restriction_help': {
'af' : add_leave_restriction_help_af,
'zu' : add_leave_restriction_help_zu
},
'translation/dialogs/add_leave_roles_help': {
'af' : add_leave_roles_help_af,
'zu' : add_leave_roles_help_zu
},
'translation/dialogs/add_new_holiday_type': {
'af' : add_new_holiday_type_af,
'zu' : add_new_holiday_type_zu
},
'translation/dialogs/add_objective_plan': {
'af' : add_objective_plan_af,
'zu' : add_objective_plan_zu
},
'translation/dialogs/add_objective_to_plan': {
'af' : add_objective_to_plan_af,
'zu' : add_objective_to_plan_zu
},
'translation/dialogs/add_overtime_rules': {
'af' : add_overtime_rules_af,
'zu' : add_overtime_rules_zu
},
'translation/dialogs/add_rating_method': {
'af' : add_rating_method_af,
'zu' : add_rating_method_zu
},
'translation/dialogs/add_time_rules': {
'af' : add_time_rules_af,
'zu' : add_time_rules_zu
},
'translation/dialogs/anonymous_survey_setup_help': {
'af' : anonymous_survey_setup_help_af,
'zu' : anonymous_survey_setup_help_zu
},
'translation/dialogs/approve_leave_help': {
'af' : approve_leave_help_af,
'zu' : approve_leave_help_zu
},
'translation/dialogs/approve_time_logged_help': {
'af' : approve_time_logged_help_af,
'zu' : approve_time_logged_help_zu
},
'translation/dialogs/approve_users_help': {
'af' : approve_users_help_af,
'zu' : approve_users_help_zu
},
'translation/dialogs/attendance_report_per_department_help': {
'af' : attendance_report_per_department_help_af,
'zu' : attendance_report_per_department_help_zu
},
'translation/dialogs/attendance_report_per_employee_help': {
'af' : attendance_report_per_employee_help_af,
'zu' : attendance_report_per_employee_help_zu
},
'translation/dialogs/available_leave_help': {
'af' : available_leave_help_af,
'zu' : available_leave_help_zu
},
'translation/dialogs/backup_manager_report_help': {
'af' : backup_manager_report_help_af,
'zu' : backup_manager_report_help_zu
},
'translation/dialogs/backup_managers_help': {
'af' : backup_managers_help_af,
'zu' : backup_managers_help_zu
},
'translation/dialogs/branches_help': {
'af' : branches_help_af,
'zu' : branches_help_zu
},
'translation/dialogs/bursaries_help': {
'af' : bursaries_help_af,
'zu' : bursaries_help_zu
},
'translation/dialogs/cancel_leave_help': {
'af' : cancel_leave_help_af,
'zu' : cancel_leave_help_zu
},
'translation/dialogs/check_attendance_report_help': {
'af' : check_attendance_report_help_af,
'zu' : check_attendance_report_help_zu
},
'translation/dialogs/companies_help': {
'af' : companies_help_af,
'zu' : companies_help_zu
},
'translation/dialogs/company_goals_help': {
'af' : company_goals_help_af,
'zu' : company_goals_help_zu
},
'translation/dialogs/contracts_help': {
'af' : contracts_help_af,
'zu' : contracts_help_zu
},
'translation/dialogs/create_cycle': {
'af' : create_cycle_af,
'zu' : create_cycle_zu
},
'translation/dialogs/cycle_setup_help': {
'af' : cycle_setup_help_af,
'zu' : cycle_setup_help_zu
},
'translation/dialogs/cycle_stage_help': {
'af' : cycle_stage_help_af,
'zu' : cycle_stage_help_zu
},
'translation/dialogs/department_growth_report_help': {
'af' : department_growth_report_help_af,
'zu' : department_growth_report_help_zu
},
'translation/dialogs/departments_help': {
'af' : departments_help_af,
'zu' : departments_help_zu
},
'translation/dialogs/diversity_statistics_report_help': {
'af' : diversity_statistics_report_help_af,
'zu' : diversity_statistics_report_help_zu
},
'translation/dialogs/documents_help': {
'af' : documents_help_af,
'zu' : documents_help_zu
},
'translation/dialogs/edit_document': {
'af' : edit_document_af,
'zu' : edit_document_zu
},
'translation/dialogs/edit_project': {
'af' : edit_project_af,
'zu' : edit_project_zu
},
'translation/dialogs/edit_transaction_type': {
'af' : edit_transaction_type_af,
'zu' : edit_transaction_type_zu
},
'translation/dialogs/education_help': {
'af' : education_help_af,
'zu' : education_help_zu
},
'translation/dialogs/eea_report_help': {
'af' : eea_report_help_af,
'zu' : eea_report_help_zu
},
'translation/dialogs/employee_add_disciplinary': {
'af' : employee_add_disciplinary_af,
'zu' : employee_add_disciplinary_zu
},
'translation/dialogs/employee_add_field': {
'af' : employee_add_field_af,
'zu' : employee_add_field_zu
},
'translation/dialogs/employee_add_linked_leave': {
'af' : employee_add_linked_leave_af,
'zu' : employee_add_linked_leave_zu
},
'translation/dialogs/employee_add_linked_leave_by_category': {
'af' : employee_add_linked_leave_by_category_af,
'zu' : employee_add_linked_leave_by_category_zu
},
'translation/dialogs/employee_add_manager_department': {
'af' : employee_add_manager_department_af,
'zu' : employee_add_manager_department_zu
},
'translation/dialogs/employee_attendance_information_help': {
'af' : employee_attendance_information_help_af,
'zu' : employee_attendance_information_help_zu
},
'translation/dialogs/employee_category_add': {
'af' : employee_category_add_af,
'zu' : employee_category_add_zu
},
'translation/dialogs/employee_convert_linked_leave_type': {
'af' : employee_convert_linked_leave_type_af,
'zu' : employee_convert_linked_leave_type_zu
},
'translation/dialogs/employee_details_help': {
'af' : employee_details_help_af,
'zu' : employee_details_help_zu
},
'translation/dialogs/employee_document_count_report_help': {
'af' : employee_document_count_report_help_af,
'zu' : employee_document_count_report_help_zu
},
'translation/dialogs/employee_document_reject': {
'af' : employee_document_reject_af,
'zu' : employee_document_reject_zu
},
'translation/dialogs/employee_documents_help': {
'af' : employee_documents_help_af,
'zu' : employee_documents_help_zu
},
'translation/dialogs/employee_employment_listing_report_help': {
'af' : employee_employment_listing_report_help_af,
'zu' : employee_employment_listing_report_help_zu
},
'translation/dialogs/employee_end_linked_leave': {
'af' : employee_end_linked_leave_af,
'zu' : employee_end_linked_leave_zu
},
'translation/dialogs/employee_field_report_help': {
'af' : employee_field_report_help_af,
'zu' : employee_field_report_help_zu
},
'translation/dialogs/employee_fields_help': {
'af' : employee_fields_help_af,
'zu' : employee_fields_help_zu
},
'translation/dialogs/employee_groups_add': {
'af' : employee_groups_add_af,
'zu' : employee_groups_add_zu
},
'translation/dialogs/employee_groups_help': {
'af' : employee_groups_help_af,
'zu' : employee_groups_help_zu
},
'translation/dialogs/employee_history_help': {
'af' : employee_history_help_af,
'zu' : employee_history_help_zu
},
'translation/dialogs/employee_import_help': {
'af' : employee_import_help_af,
'zu' : employee_import_help_zu
},
'translation/dialogs/employee_leave_coming_up_help': {
'af' : employee_leave_coming_up_help_af,
'zu' : employee_leave_coming_up_help_zu
},
'translation/dialogs/employee_leave_entry': {
'af' : employee_leave_entry_af,
'zu' : employee_leave_entry_zu
},
'translation/dialogs/employee_resign': {
'af' : employee_resign_af,
'zu' : employee_resign_zu
},
'translation/dialogs/employee_upload_document': {
'af' : employee_upload_document_af,
'zu' : employee_upload_document_zu
},
'translation/dialogs/employee_upload_leave_document': {
'af' : employee_upload_leave_document_af,
'zu' : employee_upload_leave_document_zu
},
'translation/dialogs/employee_upload_payroll_document': {
'af' : employee_upload_payroll_document_af,
'zu' : employee_upload_payroll_document_zu
},
'translation/dialogs/employee_upload_photo': {
'af' : employee_upload_photo_af,
'zu' : employee_upload_photo_zu
},
'translation/dialogs/employees_active_per_department_count_help': {
'af' : employees_active_per_department_count_help_af,
'zu' : employees_active_per_department_count_help_zu
},
'translation/dialogs/employees_currently_on_leave_help': {
'af' : employees_currently_on_leave_help_af,
'zu' : employees_currently_on_leave_help_zu
},
'translation/dialogs/employees_taking_leave_per_department_count_help': {
'af' : employees_taking_leave_per_department_count_help_af,
'zu' : employees_taking_leave_per_department_count_help_zu
},
'translation/dialogs/employees_with_roles_help': {
'af' : employees_with_roles_help_af,
'zu' : employees_with_roles_help_zu
},
'translation/dialogs/employment_listing_help': {
'af' : employment_listing_help_af,
'zu' : employment_listing_help_zu
},
'translation/dialogs/events_help': {
'af' : events_help_af,
'zu' : events_help_zu
},
'translation/dialogs/feature_roles_help': {
'af' : feature_roles_help_af,
'zu' : feature_roles_help_zu
},
'translation/dialogs/general_documents_help': {
'af' : general_documents_help_af,
'zu' : general_documents_help_zu
},
'translation/dialogs/holidays_help': {
'af' : holidays_help_af,
'zu' : holidays_help_zu
},
'translation/dialogs/import_employees': {
'af' : import_employees_af,
'zu' : import_employees_zu
},
'translation/dialogs/import_holiday': {
'af' : import_holiday_af,
'zu' : import_holiday_zu
},
'translation/dialogs/import_time_log_help': {
'af' : import_time_log_help_af,
'zu' : import_time_log_help_zu
},
'translation/dialogs/import_time_logged': {
'af' : import_time_logged_af,
'zu' : import_time_logged_zu
},
'translation/dialogs/insert_leave_entry': {
'af' : insert_leave_entry_af,
'zu' : insert_leave_entry_zu
},
'translation/dialogs/leave_adjustments_help': {
'af' : leave_adjustments_help_af,
'zu' : leave_adjustments_help_zu
},
'translation/dialogs/leave_auto_link_help': {
'af' : leave_auto_link_help_af,
'zu' : leave_auto_link_help_zu
},
'translation/dialogs/leave_available_by_company_help': {
'af' : leave_available_by_company_help_af,
'zu' : leave_available_by_company_help_zu
},
'translation/dialogs/leave_cancellation_reject': {
'af' : leave_cancellation_reject_af,
'zu' : leave_cancellation_reject_zu
},
'translation/dialogs/leave_categories_help': {
'af' : leave_categories_help_af,
'zu' : leave_categories_help_zu
},
'translation/dialogs/leave_cost_per_department_help': {
'af' : leave_cost_per_department_help_af,
'zu' : leave_cost_per_department_help_zu
},
'translation/dialogs/leave_earned_help': {
'af' : leave_earned_help_af,
'zu' : leave_earned_help_zu
},
'translation/dialogs/leave_reject': {
'af' : leave_reject_af,
'zu' : leave_reject_zu
},
'translation/dialogs/leave_restriction_rule': {
'af' : leave_restriction_rule_af,
'zu' : leave_restriction_rule_zu
},
'translation/dialogs/leave_restriction_rule_leave_type_edit': {
'af' : leave_restriction_rule_leave_type_edit_af,
'zu' : leave_restriction_rule_leave_type_edit_zu
},
'translation/dialogs/leave_restriction_rules': {
'af' : leave_restriction_rules_af,
'zu' : leave_restriction_rules_zu
},
'translation/dialogs/leave_summary_help': {
'af' : leave_summary_help_af,
'zu' : leave_summary_help_zu
},
'translation/dialogs/leave_taken_breakdown_by_leave_entry_help': {
'af' : leave_taken_breakdown_by_leave_entry_help_af,
'zu' : leave_taken_breakdown_by_leave_entry_help_zu
},
'translation/dialogs/leave_taken_by_leave_type_help': {
'af' : leave_taken_by_leave_type_help_af,
'zu' : leave_taken_by_leave_type_help_zu
},
'translation/dialogs/leave_taken_comparison_between_departments_help': {
'af' : leave_taken_comparison_between_departments_help_af,
'zu' : leave_taken_comparison_between_departments_help_zu
},
'translation/dialogs/leave_taken_help': {
'af' : leave_taken_help_af,
'zu' : leave_taken_help_zu
},
'translation/dialogs/leave_taken_per_day_count_help': {
'af' : leave_taken_per_day_count_help_af,
'zu' : leave_taken_per_day_count_help_zu
},
'translation/dialogs/leave_taken_report_help': {
'af' : leave_taken_report_help_af,
'zu' : leave_taken_report_help_zu
},
'translation/dialogs/leave_trends_help': {
'af' : leave_trends_help_af,
'zu' : leave_trends_help_zu
},
'translation/dialogs/leave_types_add': {
'af' : leave_types_add_af,
'zu' : leave_types_add_zu
},
'translation/dialogs/leave_types_help': {
'af' : leave_types_help_af,
'zu' : leave_types_help_zu
},
'translation/dialogs/linked_company_objective': {
'af' : linked_company_objective_af,
'zu' : linked_company_objective_zu
},
'translation/dialogs/log_time': {
'af' : log_time_af,
'zu' : log_time_zu
},
'translation/dialogs/log_time_employee': {
'af' : log_time_employee_af,
'zu' : log_time_employee_zu
},
'translation/dialogs/managed_departments_help': {
'af' : managed_departments_help_af,
'zu' : managed_departments_help_zu
},
'translation/dialogs/managed_employees_help': {
'af' : managed_employees_help_af,
'zu' : managed_employees_help_zu
},
'translation/dialogs/manager_subordinate_structure_help': {
'af' : manager_subordinate_structure_help_af,
'zu' : manager_subordinate_structure_help_zu
},
'translation/dialogs/managers_help': {
'af' : managers_help_af,
'zu' : managers_help_zu
},
'translation/dialogs/mobile_configuration_add_image': {
'af' : mobile_configuration_add_image_af,
'zu' : mobile_configuration_add_image_zu
},
'translation/dialogs/mobile_configuration_help': {
'af' : mobile_configuration_help_af,
'zu' : mobile_configuration_help_zu
},
'translation/dialogs/notes_help': {
'af' : notes_help_af,
'zu' : notes_help_zu
},
'translation/dialogs/objective_details_help': {
'af' : objective_details_help_af,
'zu' : objective_details_help_zu
},
'translation/dialogs/objective_measures_help': {
'af' : objective_measures_help_af,
'zu' : objective_measures_help_zu
},
'translation/dialogs/objectives_summary_help': {
'af' : objectives_summary_help_af,
'zu' : objectives_summary_help_zu
},
'translation/dialogs/open_notification_dialog': {
'af' : open_notification_dialog_af,
'zu' : open_notification_dialog_zu
},
'translation/dialogs/outstanding_data_help': {
'af' : outstanding_data_help_af,
'zu' : outstanding_data_help_zu
},
'translation/dialogs/performance_cycle_ratings_help': {
'af' : performance_cycle_ratings_help_af,
'zu' : performance_cycle_ratings_help_zu
},
'translation/dialogs/promote_demote_help': {
'af' : promote_demote_help_af,
'zu' : promote_demote_help_zu
},
'translation/dialogs/rating_distribution_help': {
'af' : rating_distribution_help_af,
'zu' : rating_distribution_help_zu
},
'translation/dialogs/rating_methods_help': {
'af' : rating_methods_help_af,
'zu' : rating_methods_help_zu
},
'translation/dialogs/register_dialog': {
'af' : register_dialog_af,
'zu' : register_dialog_zu
},
'translation/dialogs/reject_users': {
'af' : reject_users_af,
'zu' : reject_users_zu
},
'translation/dialogs/report_company_leave_available_adjust_and_refresh': {
'af' : report_company_leave_available_adjust_and_refresh_af,
'zu' : report_company_leave_available_adjust_and_refresh_zu
},
'translation/dialogs/report_leave_taken_settings': {
'af' : report_leave_taken_settings_af,
'zu' : report_leave_taken_settings_zu
},
'translation/dialogs/report_time_logged_help': {
'af' : report_time_logged_help_af,
'zu' : report_time_logged_help_zu
},
'translation/dialogs/requisition_configuration_add_image': {
'af' : requisition_configuration_add_image_af,
'zu' : requisition_configuration_add_image_zu
},
'translation/dialogs/requisition_configuration_help': {
'af' : requisition_configuration_help_af,
'zu' : requisition_configuration_help_zu
},
'translation/dialogs/setup_overtime_rules_help': {
'af' : setup_overtime_rules_help_af,
'zu' : setup_overtime_rules_help_zu
},
'translation/dialogs/setup_time_rules_help': {
'af' : setup_time_rules_help_af,
'zu' : setup_time_rules_help_zu
},
'translation/dialogs/sick_leave_cycles_information_help': {
'af' : sick_leave_cycles_information_help_af,
'zu' : sick_leave_cycles_information_help_zu
},
'translation/dialogs/skill_competency_data_help': {
'af' : skill_competency_data_help_af,
'zu' : skill_competency_data_help_zu
},
'translation/dialogs/skills_competency_help': {
'af' : skills_competency_help_af,
'zu' : skills_competency_help_zu
},
'translation/dialogs/survey_results_help': {
'af' : survey_results_help_af,
'zu' : survey_results_help_zu
},
'translation/dialogs/survey_segments': {
'af' : survey_segments_af,
'zu' : survey_segments_zu
},
'translation/dialogs/surveys_setup_add': {
'af' : surveys_setup_add_af,
'zu' : surveys_setup_add_zu
},
'translation/dialogs/surveys_setup_help': {
'af' : surveys_setup_help_af,
'zu' : surveys_setup_help_zu
},
'translation/dialogs/surveys_setup_questions_add': {
'af' : surveys_setup_questions_add_af,
'zu' : surveys_setup_questions_add_zu
},
'translation/dialogs/system_notifications_add': {
'af' : system_notifications_add_af,
'zu' : system_notifications_add_zu
},
'translation/dialogs/system_notifications_help': {
'af' : system_notifications_help_af,
'zu' : system_notifications_help_zu
},
'translation/dialogs/table_layout': {
'af' : table_layout_af,
'zu' : table_layout_zu
},
'translation/dialogs/time_logged_reject': {
'af' : time_logged_reject_af,
'zu' : time_logged_reject_zu
},
'translation/dialogs/time_management_setup_help': {
'af' : time_management_setup_help_af,
'zu' : time_management_setup_help_zu
},
'translation/dialogs/time_view_help': {
'af' : time_view_help_af,
'zu' : time_view_help_zu
},
'translation/dialogs/upcoming_birthdays_help': {
'af' : upcoming_birthdays_help_af,
'zu' : upcoming_birthdays_help_zu
},
'translation/dialogs/upload_general_document': {
'af' : upload_general_document_af,
'zu' : upload_general_document_zu
},
'translation/dialogs/view_perf_objective_plan': {
'af' : view_perf_objective_plan_af,
'zu' : view_perf_objective_plan_zu
},
'translation/dialogs/wizard_companies': {
'af' : wizard_companies_af,
'zu' : wizard_companies_zu
},
'translation/dialogs/wizard_departments': {
'af' : wizard_departments_af,
'zu' : wizard_departments_zu
},
'translation/dialogs/wizard_employee_create': {
'af' : wizard_employee_create_af,
'zu' : wizard_employee_create_zu
},
'translation/dialogs/wizard_employee_fields': {
'af' : wizard_employee_fields_af,
'zu' : wizard_employee_fields_zu
},
'translation/dialogs/wizard_finish_basic': {
'af' : wizard_finish_basic_af,
'zu' : wizard_finish_basic_zu
},
'translation/dialogs/wizard_finsh': {
'af' : wizard_finsh_af,
'zu' : wizard_finsh_zu
},
'translation/dialogs/wizard_holiday_setup': {
'af' : wizard_holiday_setup_af,
'zu' : wizard_holiday_setup_zu
},
'translation/dialogs/wizard_holidays': {
'af' : wizard_holidays_af,
'zu' : wizard_holidays_zu
},
'translation/dialogs/wizard_leave_setup_cycle': {
'af' : wizard_leave_setup_cycle_af,
'zu' : wizard_leave_setup_cycle_zu
},
'translation/dialogs/wizard_leave_setup_description': {
'af' : wizard_leave_setup_description_af,
'zu' : wizard_leave_setup_description_zu
},
'translation/dialogs/wizard_leave_setup_employees': {
'af' : wizard_leave_setup_employees_af,
'zu' : wizard_leave_setup_employees_zu
},
'translation/dialogs/wizard_leave_setup_holidays': {
'af' : wizard_leave_setup_holidays_af,
'zu' : wizard_leave_setup_holidays_zu
},
'translation/dialogs/wizard_leave_setup_overview': {
'af' : wizard_leave_setup_overview_af,
'zu' : wizard_leave_setup_overview_zu
},
'translation/dialogs/wizard_leave_setup_restrictions': {
'af' : wizard_leave_setup_restrictions_af,
'zu' : wizard_leave_setup_restrictions_zu
},
'translation/dialogs/wizard_leave_setup_roles': {
'af' : wizard_leave_setup_roles_af,
'zu' : wizard_leave_setup_roles_zu
},
'translation/dialogs/wizard_leave_types': {
'af' : wizard_leave_types_af,
'zu' : wizard_leave_types_zu
}
}
